// Schedules a single one-shot callback at ~80% of the remaining lifetime of an ICE/TURN
// credential (roadmap #11), so a long call refreshes before the backend-issued token
// expires. Kept dependency-free (no peer connection, no React) so it can be unit-tested
// with fake timers without mounting the call UI; VideoState wires the callback to the
// actual refetch + renegotiation.
const REFRESH_AT_LIFETIME_FRACTION = 0.8

export class IceRefreshScheduler {
  private timer: ReturnType<typeof setTimeout> | null = null

  // Arms onRefresh at ~80% of the time remaining until expiresAt (epoch ms, or an ISO
  // string already resolved to epoch ms by the caller). Any previously pending timer is
  // cleared first. No-ops (leaving nothing scheduled) when expiresAt is missing or already
  // in the past - today's backend does not send it, so this stays inert there and behaviour
  // is unchanged.
  schedule(expiresAt: number | null | undefined, onRefresh: () => void): void {
    this.clear()
    if (!expiresAt) {
      return
    }
    const remainingMs = expiresAt - Date.now()
    if (remainingMs <= 0) {
      return
    }
    this.timer = setTimeout(onRefresh, remainingMs * REFRESH_AT_LIFETIME_FRACTION)
  }

  // Cancels a pending refresh. Called on hang-up/unmount so a dead call never fires a
  // refresh (and the renegotiation it drives) after the peer connection is gone.
  clear(): void {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
